import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "about-this-project"
    }}>{`About this project`}</h1>
    <h2 {...{
      "id": "author"
    }}>{`Author`}</h2>
    <p>{`Encodable was developed by `}<a parentName="p" {...{
        "href": "https://kristw.yellowpigz.com"
      }}>{`Krist Wongsuphasawat`}</a>{`.`}</p>
    <h2 {...{
      "id": "publication"
    }}>{`Publication`}</h2>
    <p>{`This work was accepted for publication and will be published and presented at IEEE VIS 2020.`}</p>
    <p>{`The pre-print version of the paper is publicly available and can be found `}<a parentName="p" {...{
        "href": "https://arxiv.org/abs/2009.00722"
      }}>{`here`}</a>{`.`}</p>
    <h2 {...{
      "id": "citation"
    }}>{`Citation`}</h2>
    <blockquote>
      <p parentName="blockquote">{`K. Wongsuphasawat, "Encodable: Configurable Grammar for Visualization Components",
To appear in Proceedings of the 2020 IEEE Visualization Conference (VIS), 2020.`}</p>
    </blockquote>
    <p>{`or bibtex`}</p>
    <pre><code parentName="pre" {...{}}>{`@INPROCEEDINGS{encodable_vis,
  author={Krist Wongsuphasawat},
  booktitle={2020 IEEE Visualization Conference (VIS)},
  title={Encodable: Configurable Grammar for Visualization Components},
  year={2020},
  volume={},
  number={},
  note="To appear"}
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      